import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Balcony = (props: Icon): React.ReactElement => (
  <svg
    viewBox="0 0 40 40"
    style={{ ...style(props.size, props.height), ...props.style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-782.000000, -1155.000000)"
        fill={props.color || theme.palette.grey600}
        fillRule="nonzero"
      >
        <g transform="translate(782.000000, 1155.000000)">
          <path d="M26.6666667,28.3333333 L26.6666667,35 L25,35 L25,28.3333333 L21.666,28.333 L21.6666667,35 L30,35 L30,28.333 L26.6666667,28.3333333 Z M35,0 L35,23.333 L30,23.333 L30,15 L21.6666667,15 L21.666,23.333 L18.333,23.333 L18.3333333,15 L10,15 L10,23.333 L5,23.333 L5,0 L35,0 Z M17.5,18.3333333 C17.9248344,18.3333333 18.2754183,18.6512377 18.3268405,19.0621351 L18.333,19.166 L18.3268405,19.2711982 C18.2754183,19.6820957 17.9248344,20 17.5,20 L15.8333333,20 C15.373096,20 15,19.626904 15,19.1666667 C15,18.7064294 15.373096,18.3333333 15.8333333,18.3333333 L17.5,18.3333333 Z M24.1666667,18.3333333 C24.626904,18.3333333 25,18.7064294 25,19.1666667 C25,19.626904 24.626904,20 24.1666667,20 L22.5,20 C22.0397627,20 21.6666667,19.626904 21.6666667,19.1666667 C21.6666667,18.7064294 22.0397627,18.3333333 22.5,18.3333333 L24.1666667,18.3333333 Z M18.3333333,5 L10,5 L10,11.6666667 L18.3333333,11.6666667 L18.3333333,5 Z M30,5 L21.6666667,5 L21.6666667,11.6666667 L30,11.6666667 L30,5 Z M15,28.3333333 L15,35 L18.3333333,35 L18.333,28.333 L15,28.3333333 Z M10,28.333 L10,35 L13.3333333,35 L13.3333333,28.3333333 L10,28.333 Z M35,40 L5,40 L5,28.333 L1.66666667,28.3333333 C0.75,28.3333333 0,27.5833333 0,26.6666667 C0,25.75 0.75,25 1.66666667,25 L1.66666667,25 L38.3333333,25 C39.25,25 40,25.75 40,26.6666667 C40,27.5833333 39.25,28.3333333 38.3333333,28.3333333 L38.3333333,28.3333333 L35,28.333 L35,40 Z"></path>
        </g>
      </g>
    </g>
  </svg>
);
